





















































































import {
  Component,
  Vue,
} from 'vue-property-decorator';

import BaseModal from '@/components/BaseModal.vue';


interface CardInfo {
  cardNumber: string;
  fullName: string;
  cardDate: string;
  cvv: string;
}

@Component({
  name: 'payment-card-modal',
  components: {
    BaseModal,
  },
})
export default class PaymentCardModal extends Vue {
  private selectedTab: string = 'yearly';

  private readonly agreementCheckbox: boolean = false;

  private readonly cardInfo: CardInfo = {
    cardNumber: '',
    fullName: '',
    cardDate: '',
    cvv: '',
  };

  private get submitAvailable(): boolean {
    return !Object.values(this.cardInfo).some((_: string) => !_);
  }

  private handleClose(): void {
    this.$modal.hide('payment-card-modal');
  }

  private switchTab(tab: string): void {
    this.selectedTab = tab;
  }

  private handleSubscribe(): void {
    // handle subscribe
  }
}
